var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"900","src":"https://datastudio.google.com/embed/reporting/374c0ce0-afb4-4516-812f-94ec97cf9d29/page/fSZCC","frameborder":"0","allowfullscreen":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }